import { ReactElement } from 'react';

import { Image } from 'components';
import { ButtonV3 } from 'components/ComponentV2';

import { useAuth } from 'lib/providers/AuthProvider';
import styles from './EmptyList.module.scss';

interface EmptyListProps {
  title: string;
  description: string;
  button?: string;
  onClick?: () => void;
}

export const EmptyList = ({
  title,
  description,
  button,
  onClick,
}: EmptyListProps): ReactElement => {
  const { isManager } = useAuth();

  return (
    <section className={styles.emptyList}>
      <Image src="desert.png" source="aws" height="auto" width="98" />
      <div>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
      </div>
      {button && onClick && isManager ? (
        <ButtonV3
          className={styles['button']}
          startIcon="icon_mail"
          onClick={onClick}
          size="large"
        >
          {button}
        </ButtonV3>
      ) : (
        <></>
      )}
    </section>
  );
};
